<template>
  <table class="progress-transfer">
    <tr>
      <td colspan="2">
        {{ cpntMensagem }}
        <br/>
        <br/>
        Por favor aguarde...
        <br/>
        <br/>
      </td>
    </tr>
    <tr>
      <td colspan="2">
        <div class="progresso" :style="'height: ' + cpntHeightBar + '; border-radius: calc(' + cpntHeightBar + ' / 4);'">
          <div class="barra noselect" :style="'width: ' + porcentagem + '%; height: ' + cpntHeightBar + '; border-radius: calc(' + cpntHeightBar + ' / 4);'">&nbsp;</div>
          <div class="number" :style="'margin-top: calc((-' + cpntHeightBar + ' / 2) + (-18px / 2));'">{{ porcentagem }} %</div>
          <div style="clear: both; height: 1px;" class="noselect">&nbsp;</div>
        </div>
      </td>
    </tr>
    <tr>
      <td class="esquerda">
        <div>Velocidade:</div>
        <div v-html="velocidade"></div>
      </td>
      <td class="direita">
        <div>Concluído:</div>
        <div v-html="transferido"></div>
      </td>
    </tr>
    <tr>
      <td class="esquerda">
        <div>Tempo Restante:</div>
        <div v-html="tempo"></div>
      </td>
      <td class="direita">
        <div>Tamanho Total:</div>
        <div v-html="tamanho"></div>
      </td>
    </tr>
  </table>
</template>

<style scoped>
.progress-transfer {
  width: 100%;
}
  .progress-transfer > tr > td > .progresso {
    background-color: #777;
    width: 100%;
  }
    .progress-transfer > tr > td > .progresso,
    .progress-transfer > tr > td > .progresso > .barra {
      height: 100%;
      background-image: linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent);
      background-size: 1rem 1rem;
    }
    @-webkit-keyframes progress-bar-stripes{
      0% { background-position: 1rem 0; }
      to { background-position: 0 0; }
    }
    @keyframes progress-bar-stripes {
      0% { background-position: 1rem 0; }
      to { background-position: 0 0; }
    }
    .progress-transfer > tr > td > .progresso > .barra {
      flex-direction: column;
      justify-content: center;
      color: #fff;
      text-align: center;
      white-space: nowrap;
      background-color: #007bff;
      transition: width .6s ease;

      -webkit-animation: progress-bar-stripes 1s linear infinite;
      animation: progress-bar-stripes 1s linear infinite;
    }
    .progress-transfer > tr > td > .progresso > .number {
      color: #fff;
      text-align: center;
    }
  .progress-transfer > tr:not(:first-child) > td {
    padding: 3px 0px;
  }
  .progress-transfer > tr:not(:first-child) > td:first-child {
    text-align: left;
  }
  .progress-transfer > tr:not(:first-child) > td:last-child {
    text-align: right;
  }
    .progress-transfer > tr:not(:first-child) > td > div {
      display: inline-block;
    }
    /* .progress-transfer > tr:not(:first-child) > td:last-child > div:not(:first-child),
    .progress-transfer > tr:not(:first-child) > td:first-child > div:not(:last-child) {
      width: 110px;
      min-width: 110px;
      max-width: 110px;
    } */

    .progress-transfer > tr > .esquerda > div:first-child {
      width: 100%;
    }
    .progress-transfer > tr > .direita > div:first-child {
      width: 100%;
    }
</style>

<script>
  export default {
    props: {
      cpntMensagem: {
        required: true,
        type: String
      },
      cpntTotal: {
        required: false,
        type: Number
      },
      cpntTransferido: {
        required: true,
        type: Number
      },
      cpntHeightBar: {
        required: false,
        type: String,
        default: function () {
          return '20px'
        }
      }
    },
    data: function () {
      return {
        porcentagem: 0,
        velocidade: '0,00 MB',
        transferido: '0,00 MB',
        tempo: 'Iniciando...',
        tamanho: '0,00 MB',
        ultimoTime: 0,
        ultimoSize: 0,
        ultimo: []
      }
    },
    mounted: function () {
      // INICIA O PROCESSO DE FORMATAÇÃO DE VALORES
      this.progressCalcularProgresso()

      // INICIA O PROCESSO PARA CALCULO DA VELOCIDADE E DO TEMPO
      this.progressCalcularVelocidadeTempo()
    },
    methods: {
      progressCalcularProgresso: function () {
        // FORMATA O TAMANHO TOTAL
        this.tamanho = this.progressFormatarTamanhos(this.cpntTotal)

        // FORMATA O TAMANHO TRANSFERIDO
        this.transferido = this.progressFormatarTamanhos(this.cpntTransferido)

        // CALCULA A PORCENTAGEM CONCLUIDA
        var porcentagem = Number((this.cpntTransferido / this.cpntTotal) * 100).toFixed(2)

        // CALCULA A PORCENTAGEM CONCLUIDA
        this.porcentagem = porcentagem > 100 ? 100 : porcentagem

        // ADICIONA A ULTIMA VIZUALIZAÇÃO
        this.ultimo.push({ time: new Date().getTime(), transferido: this.cpntTransferido })

        // VERIFICA SE TEM A QUANTIDADE DESEJADA PARA CALCULAR O PROCESSO
        if ((this.porcentagem <= 0 || this.porcentagem >= 100) || (this.ultimo.length >= 3 || this.ultimo.length === 0)) {
          this.progressCalcularVelocidadeTempo()
        }

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      progressFormatarTempo: function (sec) {
        // INICIA AS VARIAVEIS
        var horas = 0
        var minutos = 0
        var segundos = 0
        var tempo = ' '

        // RETORNA O TEMPO QUE ESTÁ FINALIZANDO
        if (sec < 1) {
          return ('Menos de 1 (Um) Segundo')
        }

        // CALCULA O TEMPO PERCORRIDO
        horas = Math.floor (sec / 3600)
        minutos = Math.floor((sec - (horas * 3600)) / 60)
        segundos = Math.floor (sec - ((horas * 3600) + (minutos * 60)))

        // MONTA A FRASE DO TEMPO
        if (sec > 86400) {
          return ('Mais de 1 (Um) dia!')
        } else if (sec >= 3600) {
          tempo = horas + ' Hora(s) ' + minutos + ' Min(s). ' + segundos + ' Seg(s). '
        } else if (sec < 3600 & sec >= 60) {
          tempo = minutos + ' Minuto(s) ' + segundos + ' Seg(s). '
        } else {
          tempo = segundos + ' Segundo(s)'
        }

        // RETORNA O TEMPO MONTADO
        return tempo
      },
      progressFormatarTamanhos: function (bytes) {
        // UNIDADES DE MEDIDAS
        var siglas = [ 'Bytes', 'KB', 'MB', 'GB', 'TB' ]

        // SE O TAMANHO FOR MENOR OU IGUAL A ZERO, RETORNA ZERO
        if (bytes <= 0) {
          return '0 Byte'
        }

        // CALCULA O TAMANHO
        var indexS = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)))

        // INICIA A VARIAVEL DO TAMANHO
        var tamanho = 0

        // FAZ A DIVIZÃO DO TAMANHO, PARA PEGAR O VALOR QUEBRADO
        switch (indexS) {
          case 0:
            tamanho = (bytes / 100)
            break

          case 1:
            tamanho = (bytes / 1000) // 392392 = 392.392 KB
            break

          case 2:
            tamanho = (bytes / 1000000) // '10760269' = 10.760 MB
            break

          case 3:
            tamanho = (bytes / 1000000000) // '5992792064' = 5.990 GB
            break

          case 4:
            tamanho = (bytes / 1000000000000)
            break
        }

        // CONVERTE O VALOR PARA STRING
        tamanho = tamanho.toString().split('.')

        if (tamanho.length === 2) {
          // PEGA A CHAVE QUE DEVE USAR
          var chave = (tamanho.length - 1)

          if (tamanho[chave].length !== 3) {
            // VERIFICA A QUANTIDADE DE ZEROS QUE DEVE COLOCAR
            switch (tamanho[chave].length) {
              case 0:
                tamanho[chave] += '000'
                break
  
              case 1:
                tamanho[chave] += '00'
                break
  
              case 2:
                tamanho[chave] += '0'
                break
  
              default:
                if (tamanho[chave].length >= 4) {
                  tamanho[chave] = tamanho[chave].substring(0, 3)
                }
                break
            }
          }
        }
        
        // DEPOIS CONVERTE O ARRAY EM STRING
        tamanho = tamanho.join('.')

        // RETORNA O TAMANHO CALCULADO
        return tamanho + ' ' + siglas[indexS]
      },
      progressCalcularVelocidadeTempo: function () {
        if (this.cpntTransferido <= 0) {
          // SETA OS VALORES INICIADOS
          this.velocidade = '0,00 MB'
          this.transferido = '0,00 MB'
          this.tempo = 'Iniciando...'
          this.tamanho = '0,00 MB'
          this.ultimoTime = 0
          this.ultimoSize = 0

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()
        } else if (Number(this.porcentagem) < 100) {
          // INICIA A VARIVEL PARA CALCULAR O TEMPO
          var timeStamp = new Date().getTime()

          // PEGA OS DADOS DO VETOR
          var ultimo = JSON.parse(JSON.stringify(this.ultimo))

          // LIMPA O VETOR PARA CALCULAR NOVAMENTE A MEDIA
          this.ultimo = []

          // LIMPA OS DADOS PARA CALCULAR NOVAMENTE
          var time = 0
          var transferido = 0

          // CALCULA OS VALORES
          for (var key in ultimo) {
            time += (timeStamp - ultimo[key].time)
            transferido += (ultimo[key].transferido - this.ultimoSize)
          }

          // CALCULA A MEDIA
          var tempo = (time / ultimo.length)
          var tamanho = (transferido / ultimo.length)

          // CALCULA A VELOCIDADE ENCONTRADA
          var velocidade = ((1000 * tamanho) / tempo)

          // FORMATA O TAMANHO TRANSFERIDO
          this.velocidade = velocidade === null ? '0,00 MB' : this.progressFormatarTamanhos(velocidade)

          // CALCULA O TEMPO QUE VAI LEVAR PARA CONCLUIR
          this.tempo = this.progressFormatarTempo((this.cpntTotal - this.cpntTransferido) / velocidade)

          // SETA OS DADOS DO ULTIMO CALCULO
          this.ultimoTime = time
          this.ultimoSize = this.cpntTransferido
          
          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()
        } else if (Number(this.porcentagem) >= 100) {
          // SETA OS VALORES QUE O PROCESSO TA FINALIZANDO
          this.tempo = 'Finalizando...'

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()
        }
      }
    },
    watch: {
      cpntTransferido: function () {
        this.progressCalcularProgresso()
      }
    }
  }
</script>
